import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Select, Table } from "antd";
import svg41 from "../../../../../../assets/svg/svg41.svg";
import svg15 from "../../../../../../assets/svg/svg15.svg";
import { Link, useNavigate } from "react-router-dom";
import CardLoading from "../../../../../../components/CardLoading";
import MembersView from "./MembersView";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import ProductionVerifyModal from "./modal/ProductionVerifyModal";
import {
  fetchData,
  fetchPeriods,
} from "../../../../../../features/fetch/fetchSlice";
import moment from "moment";
import { formatText, numberWithCommas } from "../../../../../../utils";
import toast from "react-hot-toast";
import ProductionDataView from "./ProductionDataView";

function ProductionDataTable({showVerify,setShowVerify}) {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "prod/get_production_details";
  const url1 = "prod/get_production_details_summary";
  const url2 = "prod/get_production_details_summary_list";
  const { loading, data, count, periods } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    periods: state.fetch.periods,
  }));

  const { data1, count1 } = useSelector((state) => ({
    data1: state.fetch.data[url1] || [],
    count1: state.fetch.count[url1] || 0,
  }));

  const { data2 } = useSelector((state) => ({
    data2: state.fetch.data[url2] || [],
  }));
  const { activeObjSchemes, iwuaAsalObj } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["communitySchemes"],
    iwuaAsalObj: state.obj.iwuaAsalObj,
  }));
  const { refetchKey } = useSelector((state) => state.global);
  const { open, handleCancel, handleOpen } = useModalToggle();
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const [prodd1, setProdd1] = useState("");
  const [proddView, setProddView] = useState("");

  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const [openDrawer1, setOpenDrawer1] = useState(false);
  const showDrawer1 = () => {
    setOpenDrawer1(true);
  };
  const onClose1 = () => {
    setOpenDrawer1(false);
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        usrFirstname: e.target.value == "" ? null : e.target.value,
        proSchId: activeObjSchemes?.schId,
        start: 0,
        limit: null,
      })
    );
  };

  const handleView = async (item) => {
    await setProdd(item);
    await dispatch(
      fetchData({
        url: "prod/get_member",
        limit: null,
        start: 0,
        usrInstId: iwuaAsalObj?.instId,
        usrId: item?.prodUsrId,
      })
    );
    await showDrawer();
  };

  const handleView1 = async (item) => {
    await setProddView(item); 
    await showDrawer1();
  };

  const handleVerify = async (item) => {
    if(item?.prodStatus === 'APPROVED'){
      toast.error("Record is already approved")
      return
    }
    fetchDropData(item);
    await setProdd1(item);
    await handleOpen();
  };
  async function fetchDropData(item) {
    await dispatch(
      fetchData({
        url: url2,
        prodProId: periodId,
        prodCrops: item?.prodCrops,
        limit: null,
        start: 0,
      })
    );
  }

  // const [showVerify, setShowVerify] = useState(false);
  const handleOpenVerify = async () => {
    if (!showVerify) {
      await fetchDataProductionData1();
    }
    await setShowVerify(!showVerify);
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, record, index) => {
        if (record?.isGroup) {
          return {
            children: (
              <div className="scheme-custom-header">{record?.prodCrops}</div>
            ),
          };
        }

        let num = 1;
        for (let i = 0; i < index; i++) {
          if (data?.[i]?.isGroup) {
            num = 1;
          } else {
            num++;
          }
        }
        return num;
      },
    },
    {
      title: "Name",
      dataIndex: "prodFarmer",
      render: (_, record) => (record?.isGroup ? {} : _),
    },
    {
      title: "Date Registered",
      dataIndex: "prodCreatedDate",
      render: (text, record) => {
        if (record?.isGroup) {
          return {};
        }
        return text ? moment(text).format("DD-MM-YYYY") : "--";
      },
      sorter: (a, b) =>
        moment(a.prodCreatedDate).valueOf() -
        moment(b.prodCreatedDate).valueOf(),
    },
    {
      title: "Cropped Areas (Acres)",
      dataIndex: "prodCroppedArea",
      render: (_, record) => (record?.isGroup ? {} : _),
    },
    {
      title: "Total Produce (Kgs)",
      dataIndex: "prodTotalProduce",
      render: (item, record) => {
        if (record?.isGroup) {
          return {};
        }
        return <div>{numberWithCommas(item)}</div>;
      },
    },
    {
      title: "Produce Sold (Kgs)",
      dataIndex: "prodProduceSold",
      render: (_, record) => (record?.isGroup ? {} : _),
    },
    {
      title: "Average Cost per Kg (Kes)",
      dataIndex: "prodAmount",
      render: (item, record) => {
        if (record?.isGroup) {
          return {};
        }
        return <div>{numberWithCommas(item)}</div>;
      },
    },
    {
      title: "Total Possible Revenue (Kes)",
      dataIndex: "prodTotalRevenue",
      render: (item, record) => {
        if (record?.isGroup) {
          return {};
        }
        return <div>{numberWithCommas(item)}</div>;
      },
    },

    {
      title: "Actions",
      render: (item, record) => {
        if (record?.isGroup) {
          return null;
          // <button
          //   type="button"
          //   className={`${
          //     item?.status === "VERFIED" && "bg-[#BEBEBE]"
          //   } px-[.5rem] py-[.25rem] gap-[.1875rem] flex justify-center items-center rounded-[.25rem]
          //    bg-[#637381] text-white font-interSans text-[.75rem] font-[400]`}
          //   onClick={() => handleVerify(record)}
          // >
          //   Verify
          // </button>
        }
        return (
          <>
            <button onClick={() => handleView(item)}>
              <img src={svg15} alt="svg15" />
            </button>
          </>
        );
      },
    },
  ];
  const columns2 = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, record, index) => {
        if (record?.isGroup) {
          return {
            children: (
              <div className="scheme-custom-header">{record?.prodCrops}</div>
            ),
          };
        }

        let num = 1;
        for (let i = 0; i < index; i++) {
          if (data?.[i]?.isGroup) {
            num = 1;
          } else {
            num++;
          }
        }
        return num;
      },
    },
    {
      title: "Report",
      dataIndex: "prodCat",
      render: (_, record) => (record?.isGroup ? {} : _),
    },
    {
      title: "Cropped Areas (Acres)",
      dataIndex: "prodCroppedArea",
      render: (_, record) => (record?.isGroup ? {} : _),
    },
    {
      title: "Total Produce (Kgs)",
      dataIndex: "prodTotalProduce",
      render: (item, record) => {
        if (record?.isGroup) {
          return {};
        }
        return <div>{numberWithCommas(item)}</div>;
      },
    },
    {
      title: "Produce Sold (Kgs)",
      dataIndex: "prodProduceSold",
      render: (_, record) => (record?.isGroup ? {} : _),
    },
    {
      title: "Average Cost per Kg (Kes)",
      dataIndex: "prodAmount",
      render: (item, record) => {
        if (record?.isGroup) {
          return {};
        }
        return <div>{numberWithCommas(item)}</div>;
      },
    },
    {
      title: "Total Possible Revenue (Kes)",
      dataIndex: "prodTotalRevenue",
      render: (item, record) => {
        if (record?.isGroup) {
          return {};
        }
        return <div>{numberWithCommas(item)}</div>;
      },
    },
     {
          title: "Status",
          dataIndex: "prodStatus",
          render: (item,record) => {
            if (record?.isGroup) {
              return {};
            }
            const colors = {
              APPROVED: "#28A745",
              PENDING_APPROVAL: "#3250FF",
              INACTIVE: "#F44336",
            };
    
            return (
              <div
                className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
                style={{
                  backgroundColor: colors[item] || "darkGreen",
                }}
              >
                {formatText(item)}
              </div>
            );
          },
        },
     
    {
      title: "Actions",
      render: (item, record) => { 
        console.log("item",item)
        if (record?.isGroup) {
          return (
            <button
              type="button"
              className={`px-[.5rem] py-[.25rem] gap-[.1875rem] flex justify-center items-center rounded-[.25rem]
                text-white font-interSans text-[.75rem] font-[400]
               ${
                 record?.prodStatus == 'APPROVED'
                   ? "bg-[#BEBEBE] cursor-not-allowed"
                   : "bg-[#637381]"
               }`}
              onClick={() => record?.prodStatus == 'APPROVED' ? null :  handleVerify(record)}
            >
              {item?.prodStatus == "APPROVED" ? "Verified" : "Verify"}
            </button>
          );
        }
        return (
          <>
            <button onClick={() => handleView1(item)}>
              <img src={svg15} alt="svg15" />
            </button>
          </>
        );
      },
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [periodId, setPeriodId] = useState(
    periods?.length > 0 ? periods?.[0]?.proId : null
  );
 
  
  async function fetchDataProductionData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        proSchId: activeObjSchemes?.schId,
        prodProId: periodId,
        prodType: "PRODUCTION_DATA",
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  async function fetchDataProductionData1(page, size) {
    await dispatch(
      fetchData({
        url: url1,
        prodProId: periodId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 4) {
      fetchDataProductionData();
    }
  }, [refetchKey, periodId]);

  useEffect(() => {
    if (refetchKey == 4) {
      dispatch(
        fetchPeriods({
          proSchId: activeObjSchemes?.schId,
        })
      );
    }
  }, [refetchKey]);

  useEffect(()=>{
    setPeriodId(periods?.length > 0 ? periods?.[0]?.proId : null)
  },[periods])

  const onFinish = () => {};
  if (loading && !searchInput) return <CardLoading />;
 
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <div className="flex flex-col   lg:px-[1.25rem] flex-1   ">
        <div className="mt-[1.25rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className="w-full"
            form={form}
          >
            <div className="flex items-center  justify-between">
              <div className="w-full lg:w-[40%] flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
                <span className="">Select Period</span>
                <Select
                  disabled={showVerify ? true : false}
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    periods?.length > 0 &&
                    periods?.map((item) => ({
                      value: item?.proId,
                      label: item?.proPeriod,
                    }))
                  }
                  value={periodId}
                  onChange={(value) => setPeriodId(value)}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </div>
              <button
                className={`cstm-btn ${
                  showVerify
                    ? "!w-[100px] gap-x-[.5rem]"
                    : "!w-[200px] cstm-btn-2"
                }`}
                onClick={handleOpenVerify}
              >
                {showVerify ? (
                  <>
                    <img src={svg41} alt="svg41" /> Back
                  </>
                ) : (
                  "Verify Production Data"
                )}
              </button>
            </div>
          </Form>
        </div>

        {showVerify ? (
          <Table
            rowSelection={false}
            rowClassName={(record) => (record?.isGroup ? "group-row" : "")}
            bordered={false}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count1,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchDataProductionData1(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
            rowKey="key"
            columns={columns2}
            dataSource={data1}
            scroll={{ x: 1200 }}
            className="mt-[1.94rem] custom-tables"
            loading={loading}
          />
        ) : (
          <Table
            rowSelection={false}
            rowClassName={(record) => (record?.isGroup ? "group-row" : "")}
            bordered={false}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchDataProductionData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
            rowKey="key"
            columns={columns}
            dataSource={data}
            scroll={{ x: 1200 }}
            className="mt-[1.94rem] custom-tables"
            loading={loading}
          />
        )}
      </div>
      <MembersView onClose={onClose} open={openDrawer} prodd={prodd} />
      <ProductionDataView onClose={onClose1} open={openDrawer1} proddView={proddView} />
      

      <ProductionVerifyModal
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchDataProductionData1}
        prodd1={prodd1}
        data2={data2}
      />
    </div>
  );
}

export default ProductionDataTable;
